import { useState, FC } from 'react'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import { Textarea, Button, Form } from 'components/Forms'
import { Alert } from 'ui'
import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'

import { t } from 'translations'

const FeedbackModal: FC = () => {
  const dispatch = useDispatch()
  const { emailForFeedbackNotifications } = useSelector((state: MStore.RootState) => state.settings)
  const emails = useSelector((state: MStore.RootState) => state.users.userInfo?.emails)
  const replyEmail = (emails && emails[0].address) || 'noreply@merinio.com'
  const [feedback, setFeedback] = useState(false)

  const handleMerinioFeedBack = () => {
    window.Intercom('showNewMessage')
    dispatch(closeModal())
  }

  const onSubmit = async ({ feedback_textarea }) => {
    // Close the modal
    await Api.post(`/employerFeedback`, { feedback: feedback_textarea, replyEmail })
    dispatch(closeModal())
  }

  const Content = () => {
    if (!feedback)
      return (
        <div className="my-1">
          <Button text="components.feedback.GIVE_FEEDBACK_EMPLOYER" className="btn btn-outline-primary mr-2" onClick={() => setFeedback(true)} />
          <Button text="components.feedback.GIVE_FEEDBACK_MERINIO" className="btn btn-outline-primary" onClick={() => handleMerinioFeedBack()} />
        </div>
      )

    if (!emailForFeedbackNotifications)
      return (
        <Alert variant="info" className="mt-2">
          {t('components.feedback.FEEDBACK_MODAL_EMPLOYER.NOT_SUPPORTED')}
        </Alert>
      )

    return (
      <Formik enableReinitialize={true} initialValues={{ feedback_textarea: '' }} onSubmit={values => onSubmit(values)}>
        {({ status, isSubmitting, setStatus }) => {
          return (
            <Form className="mt-2">
              {/* Error message */}
              <Alert variant={status?.type} onClose={() => setStatus()} show={!!status?.msg}>
                {status?.msg}
              </Alert>
              <Textarea module="components.feedback" required name="feedback_textarea" autoComplete="false" />
              <Button className="btn btn-primary mr-2" type="submit" isSubmitting={isSubmitting} text="SUBMIT" />
              <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
            </Form>
          )
        }}
      </Formik>
    )
  }

  return (
    <BaseModal hideButtons={feedback} title={`components.feedback.FEEDBACK_MODAL_${feedback ? 'EMPLOYER' : 'NONE'}`}>
      <Content />
    </BaseModal>
  )
}

export default FeedbackModal
